module.exports = __webpack_public_path__ + "static/media/oberflex-cheneastrakannoir-1200x2490.87a25802.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-cheneastrakannoir-1200x2490.jpg
// module id = 992
// module chunks = 37